// Imports
// ------
import React from 'react';
import styled from 'styled-components';
import { breakup } from '@break';
import { Section, Div, Span, ScrollLink } from '@reuse';
import { Row, Column } from 'react-foundation';

// Styles
// ------
const Jacket = styled(Section)`
    position: relative;
`;

const Heading = styled(Div)`
    position: relative;
    width: 100%;
    margin-bottom: 1.2rem;
`;

const Menu = styled.nav`
    display: flex;
    flex-flow: column;

    ${breakup.medium`
        flex-flow: row;
        align-items: flex-end;
        justify-content: space-between;
    `}
`;


const Link = styled(Div)`
    ${ScrollLink} {
        color: white;
        padding: 1.2rem 0;

        ${breakup.medium`
            padding: 0;
        `}
    }
`;

// Components
// ------
class SubMenu extends React.PureComponent {
    render() {
        return (
            <Jacket padBottom mpad>
                <Row isExpanded>
                    <Column small={12} medium={10} pushOnMedium={1} large={8} pushOnLarge={2}>
                        <Heading>
                            <Span>{this.props.heading}</Span>
                        </Heading>

                        <Menu>
                            {this.props.links.map(({ node }, index) => {
                                const LinkURL = `#${node.title.replace(/\s/g, "")}`;

                                return (
                                    <Link key={index}>
                                        <ScrollLink href={LinkURL}>{node.title}</ScrollLink>
                                    </Link>
                                )
                            })}
                        </Menu>
                    </Column>
                </Row>
            </Jacket>
        )
    }
}

export default SubMenu;